import React, {useState, useEffect, useContext} from 'react'
import {Link, useHistory} from 'react-router-dom'

import ReactGA from 'react-ga'
import ReactPixel from 'react-facebook-pixel'

import Slideshow from '../components/slideshow'
import Spinner from './Spinner'

import {ContextApp} from '../context/ContextApp'

import footerBanner from '../assets/banner/footerFebrero.jpg'

import promo3 from '../assets/banner/1.jpg'

import cateModa from '../assets/banner/cateModaH.jpg'
import cateModaH from '../assets/banner/cateModa.jpg'

import cateHogar from '../assets/banner/cateHogar.jpg'
import cateTec from '../assets/banner/technoBarnner.jpg'

import iconMore from '../assets/img/plus.png'

import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'

export default () => {
  const history = useHistory()

  const [first, setFirst] = useState([])
  const [second, setSecond] = useState([])
  const [third, setThird] = useState([])

  const [showNav, setShowNav] = useState(false)

  const [showNav1, setShowNav1] = useState(true)
  const [showNav2, setShowNav2] = useState(false)
  const [showNav3, setShowNav3] = useState(false)

  const contextApp = useContext(ContextApp)
  const {
    topProviders,
    getAllProviders,
    paginate,
    getProductsBySubCategory,
    cleanProductsBySubCategory,
    categories,
    productsToShowInHome,
    productsToShowInHome2,
    productsToShowInHome3,
    productsToShowInHomeTec,
    productsToShowInHomeBel,
    productsToShowInHomeMod,
    productsToShowInHomeHog,
    addProductToCarShoppingById,
    getProductsToShowInHome,
    setCategoryShowOpen,
  } = contextApp

  const catTecnologia = categories.filter(
    category => category.id === 10 && category.enabled == 1,
  )

  const catBelleza = categories.filter(
    category => category.id === 44 && category.enabled == 1,
  )

  const catModa = categories.filter(
    category => category.id === 47 && category.enabled == 1,
  )

  const catHogar = categories.filter(
    category => category.id === 62 && category.enabled == 1,
  )

  //const topProvider = topProviders.filter((providers) => id > 0)

  //console.log("ENTRO",topProviders);
  const listCategories = categories.filter(
    category => category.enabled == 1 && category.id !== 65,
  )

  ReactPixel.init('622084028481459')
  ReactPixel.pageView()

  ReactGA.initialize('UA-180386301-1')
  history.listen(location => ReactGA.pageview(location.pathname))

  const [IDProvider, setIDProvider] = useState('')

  const onProviderChange = e => {
    setIDProvider(e)
  }

  const handleAllProvider = () => {
    getAllProviders()
  }

  const items = []
  topProviders.forEach(e => {
    items.push(
      <Link to={`/products/provider/${e.id}`} class="font-size-12 text-gray-5">
        <img
          style={{
            height: '100px',
            width: '100px',
            borderRadius: '50%',
            display: 'inline-block',
          }}
          src={e.logo}
          onClick={ee => onProviderChange(e.id)}
        />
      </Link>,
    )
  })
  items.push(
    <Link to={`/stores`} class="font-size-12 text-gray-5">
      <img
        style={{
          height: '50px',
          width: '50px',
          borderRadius: '50%',
          display: 'inline-block',
          alignSelf: 'center',
        }}
        src={iconMore}
        onClick={handleAllProvider}
      />
    </Link>,
  )

  const responsive = {
    0: {items: 6},
  }

  useEffect(() => {
    getProductsToShowInHome()
  }, [])
  return (
    <div id="content" className="site-content" tabindex="-1">
      {productsToShowInHome.length === 0 ? (
        <Spinner />
      ) : (
        <div className="container">
          <div id="primary" className="content-area">
            <main id="main" className="site-main">
              <Slideshow />
              <br />

              <div class="container">
                <div class="mb-6">
                  <div className="position-relative bg-white text-center z-index-2">
                    <ul
                      className="nav nav-classic nav-tab justify-content-center"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <Link
                          className="nav-link js-animation-link active "
                          id="pills-one-example1-tab"
                          data-toggle="pill"
                          href="#pills-one-example1"
                          role="tab"
                          aria-controls="pills-one-example1"
                          aria-selected="true"
                          data-target="#pills-one-example1"
                          data-link-group="groups"
                          data-animation-in="slideInUp"
                          onClick={() => {
                            if (showNav1) {
                              setShowNav1(true)
                            } else {
                              setShowNav1(true)
                              setShowNav2(false)
                              setShowNav3(false)
                            }
                          }}
                        >
                          <div className="d-md-flex justify-content-md-center align-items-md-center">
                            Destacados
                          </div>
                        </Link>
                      </li>
                      <li class="nav-item">
                        <Link
                          class="nav-link js-animation-link"
                          id="pills-two-example1-tab"
                          data-toggle="pill"
                          href="#pills-two-example1"
                          role="tab"
                          aria-controls="pills-two-example1"
                          aria-selected="false"
                          data-target="#pills-two-example1"
                          data-link-group="groups"
                          data-animation-in="slideInUp"
                          onClick={() => {
                            if (showNav2) {
                              setShowNav2(false)
                            } else {
                              setShowNav2(true)
                              setShowNav1(false)
                              setShowNav3(false)
                            }
                          }}
                        >
                          <div class="d-md-flex justify-content-md-center align-items-md-center">
                            Más Vendidos
                          </div>
                        </Link>
                      </li>
                      <li class="nav-item">
                        <Link
                          class="nav-link js-animation-link"
                          id="pills-three-example1-tab"
                          data-toggle="pill"
                          href="#pills-three-example1"
                          role="tab"
                          aria-controls="pills-three-example1"
                          aria-selected="false"
                          data-target="#pills-three-example1"
                          data-link-group="groups"
                          data-animation-in="slideInUp"
                          onClick={() => {
                            if (showNav3) {
                              setShowNav3(false)
                            } else {
                              setShowNav3(true)
                              setShowNav2(false)
                              setShowNav1(false)
                            }
                          }}
                        >
                          <div class="d-md-flex justify-content-md-center align-items-md-center">
                            Top Más Buscados
                          </div>
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className={
                        (showNav1 ? 'show active in ' : '') +
                        'tab-pane fade pt-2'
                      }
                      id="pills-one-example1"
                      role="tabpanel"
                      aria-labelledby="pills-one-example1-tab"
                      data-target-group="groups"
                    >
                      <ul className="row list-unstyled products-group no-gutters">
                        {productsToShowInHome?.map((product, index) => {
                          return (
                            <li
                              key={index}
                              className="col-6 col-md-4 col-lg-3 col-xl product-item"
                            >
                              <div class="product-item__outer h-100">
                                <div class="product-item__inner px-xl-4 p-3">
                                  <div class="product-item__body pb-xl-2">
                                    <div class="mb-2">
                                      <Link
                                        to={`/products/provider/${product.batches[0].provider_id}`}
                                        class="font-size-12 text-gray-5"
                                      >
                                        {/* {product.batches[0].provider.name} */}
                                      </Link>
                                    </div>
                                    <Link
                                      to={{
                                        pathname: `/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`,
                                        state: product.slug
                                      }}
                                      class="text-blue font-weight-bold"
                                    >
                                      {' '}
                                      <h5 class="mb-1 product-item__title">
                                        {product.name}
                                      </h5>
                                      <div class="mb-2">
                                        <a class="d-block text-center">
                                          {product.campaing?.active == 1 ? (
                                            <span class="onsale">
                                              <span class="percentage">
                                                {/* (((product.batches[0]?.regular_price-(product.batches[0].regular_price - (product.batches[0].regular_price*(product.campaing?.discount/100))).toFixed(2))/product.batches[0]?.regular_price)*100).toFixed(2) % OFF*/}
                                                {product.campaing?.discount} %
                                                OFF
                                              </span>
                                            </span>
                                          ) : (
                                            ''
                                          )}
                                          <img
                                            style={{with: '100%'}}
                                            src={product.image_url}
                                            alt="Image Description"
                                          />
                                        </a>
                                      </div>
                                    </Link>
                                    <div class="flex-center-between mb-1">
                                      <div class="prodcut-price d-flex align-items-center position-relative">
                                        <ins class="font-size-20 tex-gray-6 text-decoration-none">
                                          {' '}
                                          {product.promo_price ? (
                                            <div className="discount_amount_promo_price">
                                              <strong>${product.promo_price}</strong>
                                              <span>{product?.batches[0]?.unit_price}</span>
                                            </div>
                                          ): `$${product?.batches[0]?.unit_price}`}
                                        </ins> 
                                        {product.promo_price ? <span className="discount_promo_price">{product.active_campaign.discount_percentage.slice(0,2)}% OFF</span> : null }         
                                      </div>
                                      <div class="d-none d-xl-block prodcut-add-cart"></div>
                                    </div>
                                  </div>
                                </div>
                                {product.batches[0]?.stock === 0 ? (
                              <div className="none_stock_alert_product_item_home">
                                <span>agotado</span>
                              </div>
                            ) : null}
                            {product.promo_price ? (
                                  <div className="promo_price_show">
                                    <span>Promoción</span>
                                  </div>
                                ): null}
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                    <div
                      className={
                        (showNav2 ? 'show active in ' : '') +
                        'tab-pane fade pt-2'
                      }
                      id="pills-two-example1"
                      role="tabpanel"
                      aria-labelledby="pills-two-example1-tab"
                      data-target-group="groups"
                    >
                      <ul class="row list-unstyled products-group no-gutters">
                        {productsToShowInHome2?.map((product, index) => {
                          return (
                            <li
                              key={index}
                              className="col-6 col-md-4 col-lg-3 col-xl product-item"
                            >
                              <div class="product-item__outer h-100">
                                <div class="product-item__inner px-xl-4 p-3">
                                  <div class="product-item__body pb-xl-2">
                                    <div class="mb-2">
                                      <Link
                                        to={`/products/provider/${product.batches[0].provider?.id}`}
                                        class="font-size-12 text-gray-5"
                                      >
                                        {product.batches[0].provider?.name}
                                      </Link>
                                    </div>
                                    <Link
                                      to={`/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`}
                                      class="text-blue font-weight-bold"
                                    >
                                      {' '}
                                      <h5 class="mb-1 product-item__title">
                                        {product.name}
                                      </h5>
                                      <div class="mb-2">
                                        <a class="d-block text-center">
                                          {product.campaing?.active == 1 ? (
                                            <span class="onsale">
                                              <span class="percentage">
                                                {product.campaing?.discount} %
                                                OFF
                                                {/*(((product.batches[0]?.regular_price-(product.batches[0].regular_price - (product.batches[0].regular_price*(product.campaing?.discount/100))).toFixed(2))/product.batches[0]?.regular_price)*100).toFixed(2) % OFF */}
                                              </span>
                                            </span>
                                          ) : (
                                            ''
                                          )}
                                          <img
                                            class="img-fluid"
                                            src={product.image_url}
                                            alt="Image Description"
                                          />
                                        </a>
                                      </div>
                                    </Link>
                                    <div class="flex-center-between mb-1">
                                      <div class="prodcut-price d-flex align-items-center position-relative">
                                      <ins class="font-size-20 tex-gray-6 text-decoration-none">
                                          {' '}
                                          {product.promo_price ? (
                                            <div className="discount_amount_promo_price">
                                              <strong>${product.promo_price}</strong>
                                              <span>${product?.batches[0]?.unit_price}</span>
                                            </div>
                                          ): `$${product?.batches[0]?.unit_price}`}
                                        </ins> 
                                        {product.promo_price ? <span className="discount_promo_price">{product.active_campaign.discount_percentage.slice(0,2)}% OFF</span> : null }         
                                      </div>
                                      <div class="d-none d-xl-block prodcut-add-cart"></div>
                                    </div>
                                  </div>
                                </div>
                                {product.batches[0]?.stock === 0 ? (
                              <div className="none_stock_alert_product_item_home">
                                <span>agotado</span>
                              </div>
                            ) : null}
                            {product.promo_price ? (
                                  <div className="promo_price_show">
                                    <span>Promoción</span>
                                  </div>
                                ): null}
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                    <div
                      className={
                        (showNav3 ? 'show active in ' : '') +
                        'tab-pane fade pt-2'
                      }
                      id="pills-three-example1"
                      role="tabpanel"
                      aria-labelledby="pills-three-example1-tab"
                      data-target-group="groups"
                    >
                      <ul class="row list-unstyled products-group no-gutters">
                        {productsToShowInHome3?.map((product, index) => {
                          return (
                            <li
                              key={index}
                              className="col-6 col-md-4 col-lg-3 col-xl product-item"
                            >
                              <div class="product-item__outer h-100">
                                <div class="product-item__inner px-xl-4 p-3">
                                  <div class="product-item__body pb-xl-2">
                                    <div class="mb-2">
                                      <Link
                                        to={`/products/provider/${product.batches[0].provider_id}`}
                                        class="font-size-12 text-gray-5"
                                      >
                                        {/* {product.batches[0].provider.name} */}
                                      </Link>
                                    </div>
                                    <Link
                                      to={`/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`}
                                      class="text-blue font-weight-bold"
                                    >
                                      {' '}
                                      <h5 class="mb-1 product-item__title">
                                        {product.name}
                                      </h5>
                                      <div class="mb-2">
                                        <a class="d-block text-center">
                                          {product.campaing?.active == 1 ? (
                                            <span class="onsale">
                                              <span class="percentage">
                                                {product.campaing?.discount} %
                                                OFF
                                                {/* (((product.batches[0]?.regular_price-(product.batches[0].regular_price - (product.batches[0].regular_price*(product.campaing?.discount/100))).toFixed(2))/product.batches[0]?.regular_price)*100).toFixed(2) % OFF*/}
                                              </span>
                                            </span>
                                          ) : (
                                            ''
                                          )}
                                          <img
                                            class="img-fluid"
                                            src={product.image_url}
                                            alt="Image Description"
                                          />
                                        </a>
                                      </div>
                                    </Link>
                                    <div class="flex-center-between mb-1">
                                      <div class="prodcut-price d-flex align-items-center position-relative">
                                        <ins class="font-size-20 tex-gray-6 text-decoration-none">
                                          {' '}
                                          {product.promo_price ? (
                                            <div className="discount_amount_promo_price">
                                              <strong>${product.promo_price}</strong>
                                              <span>${product?.batches[0]?.unit_price}</span>
                                            </div>
                                          ): `$${product?.batches[0]?.unit_price}`}
                                        </ins> 
                                        {product.promo_price ? <span className="discount_promo_price">{product.active_campaign.discount_percentage.slice(0,2)}% OFF</span> : null }         
                                      </div>
                                      <div class="d-none d-xl-block prodcut-add-cart"></div>
                                    </div>
                                  </div>
                                </div>
                                {product.batches[0]?.stock === 0 ? (
                              <div className="none_stock_alert_product_item_home">
                                <span>agotado</span>
                              </div>
                            ) : null}
                            {product.promo_price ? (
                                  <div className="promo_price_show">
                                    <span>Promoción</span>
                                  </div>
                                ): null}
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                  <div
                    class="position-relative text-center z-index-2"
                    style={{marginBottom: 30}}
                  >
                    <div class=" d-flex justify-content-between border-bottom border-color-1 flex-lg-nowrap flex-wrap border-md-down-top-0 border-md-down-bottom-0">
                      <h3 class="section-title mb-0 pb-2 font-size-22">
                        Tiendas Afiliadas
                      </h3>
                    </div>
                  </div>
                  {topProviders.length === 0 ? (
                    <Spinner />
                  ) : (
                    <div className="carousel-stores-providers">
                      {topProviders.slice(0,6).map((provider, index) => {
                        const classes = ['uno', 'dos']
                        return (
                          <div className={`store-provider-home-carousel ${classes[index]}`}>
                            <Link to={`/store/company/${provider.slug}/${provider.id}`}>
                            <img src={provider.logo} alt="" />
                            </Link>
                            <span>{provider.name}</span>
                          </div>
                        )
                      })}
                      <div className="store-provider-home-more">
                        <Link to="/stores">
                        <a><span>&rarr;</span></a>
                        </Link>
                        <div>
                          <span>Descubre <span>más</span> <br />tiendas</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
      

              <br />
              <br />
              <div class="container">
                <div class="mb-6">
                  <div class="position-relative text-center z-index-2">
                    <div class=" d-flex justify-content-between border-bottom border-color-1 flex-lg-nowrap flex-wrap border-md-down-top-0 border-md-down-bottom-0">
                      <h3 class="section-title mb-0 pb-2 font-size-22">
                        Tecnología
                      </h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-xl-auto pr-lg-2">
                      <div class="min-width-200 mt-xl-5">
                        <ul class="list-group list-group-flush flex-nowrap flex-xl-wrap flex-row flex-xl-column overflow-auto overflow-xl-visble mb-3 mb-xl-0 border-top border-color-1 border-lg-top-0">
                          {catTecnologia.map(category =>
                            category.subcategories.map(subcategories =>
                              subcategories.enabled === 1 ? (
                                <li
                                  onClick={() => {
                                    getProductsBySubCategory(
                                      subcategories.id,
                                      category,
                                      subcategories.name,
                                      paginate,
                                      0,
                                      0,
                                      0,
                                    )
                                    cleanProductsBySubCategory()
                                  }}
                                  class="border-color-1 list-group-item border-lg-down-0 flex-shrink-0 flex-xl-shrink-1"
                                >
                                  <Link
                                    to={`/productos/subcategoria/${subcategories.slug}/${subcategories.id}`}
                                    class="hover-on-bold py-1 px-3 text-gray-90 d-block"
                                  >
                                    {subcategories.name}
                                  </Link>
                                </li>
                              ) : null,
                            ),
                          )}
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-auto">
                      <a class="d-block">
                        <img
                          class="img-fluid"
                          src={cateTec}
                          alt="Image Description"
                        />
                      </a>
                    </div>
                    <div class="col-md pl-md-0">
                      <ul class="row list-unstyled products-group no-gutters mb-0">
                        {productsToShowInHomeTec.length === 0 ? (
                          <Spinner />
                        ) : (
                          productsToShowInHomeTec?.slice(0,6).map((product, index) => {
                            return (
                              <li
                                key={index}
                                className="col-6 col-md-4 col-wd-3 product-item"
                              >
                                <div class="product-item__outer h-100">
                                  <div class="product-item__inner bg-white p-3">
                                    <div class="product-item__body pb-xl-2">
                                      <div class="mb-2">
                                        <Link
                                          to={`/products/provider/${product.batches[0].provider_id}`}
                                          class="font-size-12 text-gray-5"
                                        >
                                          {/* {product.batches[0].provider.name} */}
                                        </Link>
                                      </div>
                                      <Link
                                        to={`/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`}
                                        class="text-blue font-weight-bold"
                                      >
                                        {' '}
                                        <h5 class="mb-1 product-item__title">
                                          {product.name}
                                        </h5>
                                        <div class="mb-2">
                                          <a class="d-block text-center">
                                            {product.campaing?.active == 1 ? (
                                              <span class="onsale">
                                                <span class="percentage">
                                                  {product.campaing?.discount} %
                                                  OFF
                                                  {/*(((product.batches[0]?.regular_price-(product.batches[0].regular_price - (product.batches[0].regular_price*(product.campaing?.discount/100))).toFixed(2))/product.batches[0]?.regular_price)*100).toFixed(2) % OFF*/}
                                                </span>
                                              </span>
                                            ) : (
                                              ''
                                            )}
                                            <img
                                              style={{with: '100%'}}
                                              src={product.image_url}
                                              alt="Image Description"
                                            />
                                          </a>
                                        </div>
                                      </Link>
                                      <div class="flex-center-between mb-1">
                                        <div class="prodcut-price d-flex align-items-center position-relative">
                                          <ins class="font-size-20 tex-gray-6 text-decoration-none">
                                            {' '}
                                            {product.promo_price ? (
                                              <div className="discount_amount_promo_price">
                                                <strong>${product.promo_price}</strong>
                                                <span>${product?.batches[0]?.unit_price}</span>
                                              </div>
                                            ): `$${product?.batches[0]?.unit_price}`}
                                          </ins>    
                                          {product.promo_price ? <span className="discount_promo_price">{product.active_campaign.discount_percentage.slice(0,2)}% OFF</span> : null }         
                                        </div>
                                        <div class="d-none d-xl-block prodcut-add-cart"></div>
                                      </div>
                                    </div>
                                  </div>
                                  {product.batches[0]?.stock === 0 ? (
                              <div className="none_stock_alert_product_item_home">
                                <span>agotado</span>
                              </div>
                            ) : null}
                                </div>
                                {product.promo_price ? (
                                  <div className="promo_price_show">
                                    <span>Promoción</span>
                                  </div>
                                ): null}
                              </li>
                            )
                          })
                        )}
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="mb-6">
                  <div class="position-relative text-center z-index-2">
                    <div class=" d-flex justify-content-between border-bottom border-color-1 flex-lg-nowrap flex-wrap border-md-down-top-0 border-md-down-bottom-0">
                      <h3 class="section-title mb-0 pb-2 font-size-22">
                        Belleza
                      </h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-xl-auto pr-lg-2">
                      <div class="min-width-200 mt-xl-5">
                        <ul class="list-group list-group-flush flex-nowrap flex-xl-wrap flex-row flex-xl-column overflow-auto overflow-xl-visble mb-3 mb-xl-0 border-top border-color-1 border-lg-top-0">
                          {catBelleza.map(category =>
                            category.subcategories.map(subcategories =>
                              subcategories.enabled === 1 ? (
                                <li
                                  onClick={() => {
                                    getProductsBySubCategory(
                                      subcategories.id,
                                      category,
                                      subcategories.name,
                                      paginate,
                                      0,
                                      0,
                                      0,
                                    )
                                    cleanProductsBySubCategory()
                                  }}
                                  class="border-color-1 list-group-item border-lg-down-0 flex-shrink-0 flex-xl-shrink-1"
                                >
                                  <Link
                                    to={`/productos/subcategoria/${subcategories.slug}/${subcategories.id}`}
                                    class="hover-on-bold py-1 px-3 text-gray-90 d-block"
                                  >
                                    {subcategories.name}
                                  </Link>
                                </li>
                              ) : null,
                            ),
                          )}
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-auto">
                      <a class="d-block">
                        <img
                          class="img-fluid"
                          src={cateModa}
                          alt="Image Description"
                        />
                      </a>
                    </div>
                    <div class="col-md pl-md-0">
                      <ul class="row list-unstyled products-group no-gutters mb-0">
                        {productsToShowInHomeBel?.length === 0 ? (
                          <Spinner />
                        ) : (
                          productsToShowInHomeBel.slice(0,6).map((product, index) => {
                            return (
                              <li
                                key={index}
                                className="col-6 col-md-4 col-wd-3 product-item"
                              >
                                <div class="product-item__outer h-100">
                                  <div class="product-item__inner bg-white p-3">
                                    <div class="product-item__body pb-xl-2">
                                      <div class="mb-2">
                                        <Link
                                          to={`/products/provider/${product.batches[0].provider_id}`}
                                          class="font-size-12 text-gray-5"
                                        >
                                          {/* {product.batches[0].provider.name} */}
                                        </Link>
                                      </div>
                                      <Link
                                        to={`/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`}
                                        class="text-blue font-weight-bold"
                                      >
                                        {' '}
                                        <h5 class="mb-1 product-item__title">
                                          {product.name}
                                        </h5>
                                        <div class="mb-2">
                                          <a class="d-block text-center">
                                    
                                            <img
                                              style={{with: '100%'}}
                                              src={product.image_url}
                                              alt="Image Description"
                                            />
                                          </a>
                                        </div>
                                      </Link>
                                      <div class="flex-center-between mb-1">
                                        <div class="prodcut-price d-flex align-items-center position-relative">
                                        <ins class="font-size-20 tex-gray-6 text-decoration-none">
                                          {' '}
                                          {product.promo_price ? (
                                            <div className="discount_amount_promo_price">
                                              <strong>${product.promo_price}</strong>
                                              <span>{product?.batches[0]?.unit_price}</span>
                                            </div>
                                          ): `$${product?.batches[0]?.unit_price}`}
                                        </ins> 
                                        {product.promo_price ? <span className="discount_promo_price">{product.active_campaign.discount_percentage.slice(0,2)}% OFF</span> : null }         
                                        </div>
                                        <div class="d-none d-xl-block prodcut-add-cart"></div>
                                      </div>
                                    </div>
                                  </div>
                                  {product.batches[0]?.stock === 0 ? (
                              <div className="none_stock_alert_product_item_home">
                                <span>agotado</span>
                              </div>
                            ) : null}
                            {product.promo_price ? (
                                  <div className="promo_price_show">
                                    <span>Promoción</span>
                                  </div>
                                ): null}
                                </div>
                              </li>
                            )
                          })
                        )}
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="mb-6">
                  <div class="position-relative text-center z-index-2">
                    <div class=" d-flex justify-content-between border-bottom border-color-1 flex-lg-nowrap flex-wrap border-md-down-top-0 border-md-down-bottom-0">
                      <h3 class="section-title mb-0 pb-2 font-size-22">Moda</h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-xl-auto pr-lg-2">
                      <div class="min-width-200 mt-xl-5">
                        <ul class="list-group list-group-flush flex-nowrap flex-xl-wrap flex-row flex-xl-column overflow-auto overflow-xl-visble mb-3 mb-xl-0 border-top border-color-1 border-lg-top-0">
                          {catModa.map(category =>
                            category.subcategories.map(subcategories =>
                              subcategories.enabled === 1 ? (
                                <li
                                  onClick={() => {
                                    getProductsBySubCategory(
                                      subcategories.id,
                                      category,
                                      subcategories.name,
                                      paginate,
                                      0,
                                      0,
                                      0,
                                    )
                                    cleanProductsBySubCategory()
                                  }}
                                  class="border-color-1 list-group-item border-lg-down-0 flex-shrink-0 flex-xl-shrink-1"
                                >
                                  <Link
                                    to={`/productos/subcategoria/${subcategories.slug}/${subcategories.id}`}
                                    class="hover-on-bold py-1 px-3 text-gray-90 d-block"
                                  >
                                    {subcategories.name}
                                  </Link>
                                </li>
                              ) : null,
                            ),
                          )}
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-auto">
                      <a class="d-block">
                        <img
                          class="img-fluid"
                          src={cateModaH}
                          alt="Image Description"
                        />
                      </a>
                    </div>
                    <div class="col-md pl-md-0">
                      <ul class="row list-unstyled products-group no-gutters mb-0">
                        {productsToShowInHomeMod.length === 0 ? (
                          <Spinner />
                        ) : (
                          productsToShowInHomeMod?.slice(0,6).map((product, index) => {
                            return (
                              <li
                                key={index}
                                className="col-6 col-md-4 col-wd-3 product-item"
                              >
                                <div class="product-item__outer h-100">
                                  <div class="product-item__inner bg-white p-3">
                                    <div class="product-item__body pb-xl-2">
                                      <div class="mb-2">
                                        <Link
                                          to={`/products/provider/${product.batches[0].provider_id}`}
                                          class="font-size-12 text-gray-5"
                                        >
                                          {/* {product.batches[0].provider.name} */}
                                        </Link>
                                      </div>
                                      <Link
                                        to={`/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`}
                                        class="text-blue font-weight-bold"
                                      >
                                        {' '}
                                        <h5 class="mb-1 product-item__title">
                                          {product.name}
                                        </h5>
                                        <div class="mb-2">
                                          <a class="d-block text-center">
                                            
                                            <img
                                              style={{with: '100%'}}
                                              src={product.image_url}
                                              alt="Image Description"
                                            />
                                          </a>
                                        </div>
                                      </Link>
                                      <div class="flex-center-between mb-1">
                                        <div class="prodcut-price d-flex align-items-center position-relative">
                                          <ins class="font-size-20 tex-gray-6 text-decoration-none">
                                            {' '}
                                            {product.promo_price ? (
                                              <div className="discount_amount_promo_price">
                                                <strong>${product.promo_price}</strong>
                                                <span>${product?.batches[0]?.unit_price}</span>
                                              </div>
                                            ): `$${product?.batches[0]?.unit_price}`}
                                          </ins> 
                                          {product.promo_price ? <span className="discount_promo_price">{product.active_campaign.discount_percentage.slice(0,2)}% OFF</span> : null }         
                                        </div>
                                        <div class="d-none d-xl-block prodcut-add-cart"></div>
                                      </div>
                                    </div>
                                  </div>
                                  {product.batches[0]?.stock === 0 ? (
                              <div className="none_stock_alert_product_item_home">
                                <span>agotado</span>
                              </div>
                            ) : null}
                            {product.promo_price ? (
                                  <div className="promo_price_show">
                                    <span>Promoción</span>
                                  </div>
                                ): null}
                                </div>
                              </li>
                            )
                          })
                        )}
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="mb-6">
                  <div class="position-relative text-center z-index-2">
                    <div class=" d-flex justify-content-between border-bottom border-color-1 flex-lg-nowrap flex-wrap border-md-down-top-0 border-md-down-bottom-0">
                      <h3 class="section-title mb-0 pb-2 font-size-22">
                        Hogar
                      </h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-xl-auto pr-lg-2">
                      <div class="min-width-200 mt-xl-5">
                        <ul class="list-group list-group-flush flex-nowrap flex-xl-wrap flex-row flex-xl-column overflow-auto overflow-xl-visble mb-3 mb-xl-0 border-top border-color-1 border-lg-top-0">
                          {catHogar.map(category =>
                            category.subcategories.map(subcategories =>
                              subcategories.enabled === 1 ? (
                                <li
                                  onClick={() => {
                                    getProductsBySubCategory(
                                      subcategories.id,
                                      category,
                                      subcategories.name,
                                      paginate,
                                      0,
                                      0,
                                      0,
                                    )
                                    cleanProductsBySubCategory()
                                  }}
                                  class="border-color-1 list-group-item border-lg-down-0 flex-shrink-0 flex-xl-shrink-1"
                                >
                                  <Link
                                    to={`/productos/subcategoria/${subcategories.slug}/${subcategories.id}`}
                                    class="hover-on-bold py-1 px-3 text-gray-90 d-block"
                                  >
                                    {subcategories.name}
                                  </Link>
                                </li>
                              ) : null,
                            ),
                          )}
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-auto">
                      <a class="d-block">
                        <img
                          class="img-fluid"
                          src={cateHogar}
                          alt="Image Description"
                        />
                      </a>
                    </div>
                    <div class="col-md pl-md-0">
                      <ul class="row list-unstyled products-group no-gutters mb-0">
                        {productsToShowInHomeHog.length === 0 ? (
                          <Spinner />
                        ) : (
                          productsToShowInHomeHog?.slice(0,6).map((product, index) => {
                            return (
                              <li
                                key={index}
                                className="col-6 col-md-4 col-wd-3 product-item"
                              >
                                <div class="product-item__outer h-100">
                                  <div class="product-item__inner bg-white p-3">
                                    <div class="product-item__body pb-xl-2">
                                      <div class="mb-2">
                                        <Link
                                          to={`/products/provider/${product.batches[0].provider_id}`}
                                          class="font-size-12 text-gray-5"
                                        >
                                          {/* {product.batches[0].provider.name} */}
                                        </Link>
                                      </div>
                                      <Link
                                        to={`/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`}
                                        class="text-blue font-weight-bold"
                                      >
                                        {' '}
                                        <h5 class="mb-1 product-item__title">
                                          {product.name}
                                        </h5>
                                        <div class="mb-2">
                                          <a class="d-block text-center">
                                            
                                            <img
                                              style={{with: '100%'}}
                                              src={product.image_url}
                                              alt="Image Description"
                                            />
                                          </a>
                                        </div>
                                      </Link>
                                      <div class="flex-center-between mb-1">
                                        <div class="prodcut-price d-flex align-items-center position-relative">
                                          <ins class="font-size-20 tex-gray-6 text-decoration-none">
                                            {' '}
                                            {product.promo_price ? (
                                              <div className="discount_amount_promo_price">
                                                <strong>${product.promo_price}</strong>
                                                <span>${product?.batches[0]?.unit_price}</span>

                                              </div>
                                            ): `$${product?.batches[0]?.unit_price}`}
                                          </ins> 
                                          {product.promo_price ? <span className="discount_promo_price">{product.active_campaign.discount_percentage.slice(0,2)}% OFF</span> : null }         
                                        </div>
                                        <div class="d-none d-xl-block prodcut-add-cart"></div>
                                      </div>
                                    </div>
                                  </div>
                                  {product.batches[0]?.stock === 0 ? (
                              <div className="none_stock_alert_product_item_home">
                                <span>agotado</span>
                              </div>
                            ) : null}
                            {product.promo_price ? (
                                  <div className="promo_price_show">
                                    <span>Promoción</span>
                                  </div>
                                ): null}
                                </div>
                              </li>
                            )
                          })
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      )}
    </div>
  )
}
